import React, { useEffect, useState } from 'react';
import { withStyles } from "@material-ui/core";
import withWidth from '@material-ui/core/withWidth';

const styles = theme => ({
    versionMarker: {
        position: 'fixed',
        top: 30,
        right: 30,
        color: 'red',
        fontWeight: 'bold'
    }
});

function EnvViewer(props) {
    const isProd = process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'production'
    if (isProd) return null

    const { width, height } = useWindowSize();
    const { short } = props;

    let versioning
    if (short) {
        versioning = <div>REACT_APP_ENV={process.env.REACT_APP_ENV}</div>
    } else {
        versioning = Object.keys(process.env).map((k, i) => {
            return (
                <div key={i}>
                    {k}={process.env[k]}
                </div>
            )
        })
    }

    return (
        <div className={props.classes.versionMarker}>
            <div>{`${width} (${props.width}) x ${height}`}</div>
            {versioning}
        </div>
    )
}

// Hook
export function useWindowSize() {
    const isClient = typeof window === 'object';

    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
        if (!isClient) {
            return false;
        }

        function handleResize() {
            setWindowSize(getSize());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []); // Empty array ensures that effect is only run on mount and unmount

    return windowSize;
}

export default withStyles(styles)(withWidth()(EnvViewer))
